import type { ComponentType } from 'react';

import { withAuth } from '@/core/auth/with-auth';

/**
 * Higher-order component that wraps a route component with authentication protection.
 * Redirects unauthenticated users to /auth (login page).
 * Note: Welcome page is only shown at root path (/), not from protected route redirects.
 */
export function withProtectedRoute<P extends object>(
  Component: ComponentType<P>,
): ComponentType<P> {
  return withAuth(Component, {
    redirectTo: '/auth',
  });
}
